import { UitkSecondaryButton } from "uitk-react-button";
import * as React from "react";
import { AnalyticsStore } from "bernie-core";
import { ILocalization } from "bernie-l10n";
import { HotelsFlexModuleResult } from "typings/microserviceModels/hotels-flex-module";
import { inject } from "mobx-react";
import { AnalyticsConfig } from "uitk-react-utils";
import {
  Action,
  FlexTrackingInfo,
  sendDelayedTrackEvent
} from "components/utility/analytics/FlexAnalyticsUtils";

export const ViewAllHotelsButton = inject("analytics")(
  ({
    l10n,
    model,
    analytics
  }: {
    l10n: ILocalization;
    model: HotelsFlexModuleResult;
    analytics?: AnalyticsStore;
  }) => {
    /* istanbul ignore next line */
    const analyticsConfig: AnalyticsConfig = {
      id: "TG.LP.Dest.Hotels.SeeAll",
      callback: (id, description) => {
        const flexTrackingInfo: FlexTrackingInfo = {
          moduleName: id,
          action: Action.CLICK,
          linkName: description
        };
        sendDelayedTrackEvent(flexTrackingInfo, analytics);
      }
    };

    return (
      <div className="uitk-type-center">
        <UitkSecondaryButton
          text={l10n.formatText("hotels.seeAllHotels", model.totalHotels, model.locationName)}
          href={model.seeAllLink}
          tag="a"
          analytics={analyticsConfig}
        />
      </div>
    );
  }
);
